module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Semibold.388bb08d.woff2";